export const ProjectsIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 10C2 7.79086 3.79086 6 6 6H18C20.2091 6 22 7.79086 22 10V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V10Z"
                fill="#9FA9BC"
            />
            <path
                d="M9 7V5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7"
                stroke="#1F1F1F"
                strokeWidth="2"
            />
            <path
                d="M2 10C2 7.79086 3.79086 6 6 6H18C20.2091 6 22 7.79086 22 10C22 12.2091 20.2091 14 18 14H6C3.79086 14 2 12.2091 2 10Z"
                fill="#E3ECF3"
            />
            <rect
                x="10"
                y="13"
                width="4"
                height="3"
                rx="1"
                fill="white"
            />
        </svg>
    );
};
